import { render, staticRenderFns } from "./KualaSelangor.vue?vue&type=template&id=c0b1574e&"
import script from "./KualaSelangor.vue?vue&type=script&lang=js&"
export * from "./KualaSelangor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports